import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/vercel/path0/apps/web/providers/query-client.tsx");
